
export const deg2rad = (deg) => deg * Math.PI / 180;
export const rad2deg = (rad) => rad * 180 / Math.PI;
let earthRadius = 6378137.0;
export const rad2meters = (rad) => earthRadius * rad;
export const meters2rad = (length) => length / earthRadius;

export const rad2miles = rad => rad * 3963.1905919430524;

export const calculateDistance = (pnt1, pnt2) => {
  let dlon = deg2rad(pnt2[0] - pnt1[0]);
  let dlat = deg2rad(pnt2[1] - pnt1[1]);
  let a = Math.pow(Math.sin(dlat / 2), 2) + Math.pow(Math.sin(dlon / 2), 2) * Math.cos(deg2rad(pnt1[1])) * Math.cos(deg2rad(pnt2[1]));
  return 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const polarPoint = (origin, distance, bearingRad) => {
  let longitude1 = deg2rad(origin[0]);
  let latitude1 = deg2rad(origin[1]);

  let latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(distance) + Math.cos(latitude1) * Math.sin(distance) * Math.cos(bearingRad));
  let longitude2 = longitude1 + Math.atan2(Math.sin(bearingRad) * Math.sin(distance) * Math.cos(latitude1), Math.cos(distance) - Math.sin(latitude1) * Math.sin(latitude2));
  let lng = rad2deg(longitude2);
  let lat = rad2deg(latitude2);
  return [lng, lat];
};

export const circlePolyline = (center, radius) => {
  let steps = 64;
  return new Array(steps).fill(0).map((_, ind) => ind).concat(0)
    .map((f) => polarPoint(center, radius, f * 2 * Math.PI / steps));
};
